import React from 'react';
import { useTranslation } from 'react-i18next'; // ✅ i18n
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

const ReviewCard = ({ review }) => {
    const { t } = useTranslation(); // ✅ i18n hook
    if (!review) return null;

    const goldColor = '#c5a059';
    
    const ratingValue = review.rating || review.stars || 0;
    const commentText = review.reviewText || review.text || "";
    const authorName = review.reviewerName || review.name || t('review_anonymous'); // ✅ Թարգմանված

    const stars = Array(5).fill(0).map((_, index) => (
        <FontAwesomeIcon
            key={index}
            icon={faStar}
            style={{ 
                color: index < ratingValue ? goldColor : '#e2e8f0', 
                marginRight: '3px',
                fontSize: '14px'
            }}
        />
    ));

    const firstLetter = authorName.charAt(0).toUpperCase();

    return (
        <div style={cardStyle}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
                <div style={avatarStyle}>{firstLetter}</div>
                <div style={ratingContainerStyle}>{stars}</div>
            </div>
            
            <p style={textStyle}>
                "{commentText.length > 200 ? commentText.substring(0, 200) + "..." : commentText}"
            </p>
            
            <div style={footerStyle}>
                <div style={dividerStyle}></div>
                <p style={reviewerStyle}><strong>{authorName}</strong></p>
            </div>
        </div>
    );
};
// ... (styles remain the same)

// --- Styles ---
const cardStyle = {
    backgroundColor: '#ffffff',
    padding: '24px',
    borderRadius: '20px',
    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.04)',
    border: '1px solid #f1f5f9',
    borderLeft: '5px solid #c5a059', // Մեր ոսկեգույն բրենդային գիծը
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.3s ease',
    height: '100%'
};

const avatarStyle = {
    width: '35px',
    height: '35px',
    background: '#0f172a',
    color: '#fff',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: '700',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
};

const ratingContainerStyle = { display: 'flex' };

const textStyle = { 
    fontSize: '15px', 
    color: '#475569', 
    fontStyle: 'italic', 
    lineHeight: '1.6',
    flexGrow: 1,
    margin: '0 0 20px 0'
};

const footerStyle = {
    marginTop: 'auto'
};

const dividerStyle = {
    width: '30px',
    height: '2px',
    background: '#c5a059',
    marginBottom: '8px',
    borderRadius: '2px'
};

const reviewerStyle = { 
    margin: 0, 
    fontSize: '14px', 
    color: '#0f172a',
    textTransform: 'capitalize'
};

export default ReviewCard;